module.exports = __webpack_public_path__ + "img/Meituan_logo.7f87ef79.png";